module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }